import { useSearchParams } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Reveal, MaskedLine, Label } from "../components/Reveal";
import { QuoteForm } from "../components/QuoteForm";

const Devis = () => {
  const [params] = useSearchParams();
  const revetement = params.get("revetement") || "";

  return (
    <>
      <Seo
        title="Parlez-nous de votre projet — Demande de devis | Resineko"
        description="Décrivez votre projet de revêtement de sol : résine, béton ciré, moquette de pierre ou peinture. Resineko vous répond avec un devis personnalisé, partout en France."
        path="/devis"
      />

      <section className="noise-bg relative overflow-hidden bg-[#0A0A0A] pb-24 pt-40 md:pb-36 md:pt-52" data-testid="devis-page">
        <div
          className="pointer-events-none absolute inset-0 opacity-50"
          style={{ background: "radial-gradient(ellipse 70% 45% at 80% 0%, rgba(4,120,87,0.18), transparent)" }}
        />
        <div className="relative mx-auto max-w-7xl px-5 md:px-10">
          <span className="block overflow-hidden">
            <MaskedLine delay={0.1}><Label>Demande de devis</Label></MaskedLine>
          </span>
          <h1 className="mt-6 font-serif text-4xl font-light leading-[1.02] text-[#F4F4F0] sm:text-5xl lg:text-6xl" data-testid="devis-h1">
            <MaskedLine delay={0.25}>Parlez-nous de</MaskedLine>
            <MaskedLine delay={0.38}><em className="not-italic text-[#2FBF8F]">votre projet</em></MaskedLine>
          </h1>
          <span className="block overflow-hidden">
            <MaskedLine delay={0.5} className="mt-6 max-w-xl">
              <p className="text-base leading-relaxed text-[#8C8C8C] md:text-lg">
                Vous ne savez pas quel revêtement choisir ? Décrivez-nous votre projet et Resineko vous orientera vers la solution la plus adaptée.
              </p>
            </MaskedLine>
          </span>

          <div className="mt-16">
            <Reveal delay={0.1}>
              <div className="mx-auto max-w-4xl border border-white/10 bg-[#111111] p-6 md:p-10">
                <QuoteForm defaultRevetement={revetement} />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
};

export default Devis;
